module.exports = __webpack_public_path__ + "img/radio-on-20.56c6ea5f.svg";